import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { FBoxContainer, FHSkeletonLoader } from '../../../../components/base';
import { history } from '../../../../helpers';
import { FORTA_BLUE } from '../../../../utils/colors';
import { DASHBOARD_SECTION_CONTENT_SX, DASHBOARD_SECTION_SX } from '../styles';
import { ActivityCard } from './components';
import { useYourActivities } from './hooks';
import { ACTIVITY_ROW_SX } from './styles';
import { getActivityPath } from './utils';

import type { Activity } from './types';

function YourActivities() {
  const { t } = useTranslation('dashboard');
  const { loading, activities } = useYourActivities();

  if (loading) return <FHSkeletonLoader sx={{ mt: 3 }} />;
  if (activities.length === 0) return null;

  const goToActivity = (activity: Activity) => history.navigate(getActivityPath(activity));

  return (
    <FBoxContainer
      dataTestId="yourActivitiesSection"
      sx={DASHBOARD_SECTION_SX}
      contentStyle={DASHBOARD_SECTION_CONTENT_SX}
    >
      <Typography fontSize={21} textAlign="left" mb={2} color={FORTA_BLUE.primary}>
        {t('sections.yourActivities')}
      </Typography>
      <Box sx={ACTIVITY_ROW_SX}>
        {activities.map((activity) => (
          <ActivityCard
            key={`${activity.type}-${activity.id}`}
            activity={activity}
            onClick={() => goToActivity(activity)}
          />
        ))}
      </Box>
    </FBoxContainer>
  );
}

export default YourActivities;
